export default __webpack_public_path__ + "static/media/layer1.de318828.png";